export const SelectOptionsProCliStatusDataProcessor = (data, defaultValue) => {
  const newArr = defaultValue ? [{ id: "", name: defaultValue }] : [];
  for (let i = 0; i < data.length; i++) {
    newArr.push({ id: data[i].provider.pk, name: data[i].provider.name });
  }
  return newArr;
};
